export const MAINTENANCE_CAMPAIGN_SUCCESS = 'MAINTENANCE_CAMPAIGN_SUCCESS' as const;
export const MAINTENANCE_CAMPAIGN_ERROR = 'MAINTENANCE_CAMPAIGN_ERROR' as const;
